/** @graphql cc **/
import gql from 'graphql-tag';

export const ReadTimeQuery = gql`
	query ReadTimeQuery($contentId: ID, $status: [String], $includeContentBody: Boolean = true) {
		content(id: $contentId, status: $status) {
			nodes {
				id
				type
				body @include(if: $includeContentBody) {
					dynamic {
						value
						representation
					}
				}
				operations {
					operation
					targetType
				}
			}
		}
	}
`;
